import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import { BoardSidebarLoadingError } from 'app/src/components/BoardSidebarLoadingError';

export const LazyBoardMenuSidebar = () => {
  const BoardMenu = useLazyComponent(
    () => import(/* webpackChunkName: "board-menu" */ './BoardMenu'),
    {
      namedImport: 'BoardMenu',
    },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Board Menu',
      }}
    >
      <ChunkLoadErrorBoundary fallback={<BoardSidebarLoadingError />}>
        <Suspense fallback={null}>
          <BoardMenu />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
